import { useDispatch, useSelector } from "react-redux";
import { useCallback, useRef } from "react";
import { premiumCalculatePost } from "../../../store/premiumCalculate/actions";
export var usePremiumCalculate = function (productCode, planCode, birthDate, gender) {
    var dispatch = useDispatch();
    var birthDateRef = useRef(birthDate);
    var genderRef = useRef(gender);
    var lastBody = useRef(null);
    birthDateRef.current = birthDate;
    genderRef.current = gender;
    var _a = useSelector(function (state) { return ({
        loadingCalculate: state.PremiumCalculate.loadingCalculate,
        responseCalculate: state.PremiumCalculate.responseCalculate,
        errorCalculate: state.PremiumCalculate.errorCalculate,
    }); }), loadingCalculate = _a.loadingCalculate, responseCalculate = _a.responseCalculate, errorCalculate = _a.errorCalculate;
    var calculatePremium = useCallback(function (coverageAmount, paymentMode) {
        var resolvedPlanCode = (planCode === null || planCode === void 0 ? void 0 : planCode.includes("/"))
            ? planCode.split("/")[1]
            : planCode;
        var body = {
            productCode: productCode,
            planCode: resolvedPlanCode,
            inputData: {
                birthDate: birthDateRef.current,
                gender: genderRef.current,
                smokes: false,
                coverageAmount: Number(coverageAmount),
                paymentMode: paymentMode,
            },
        };
        lastBody.current = body;
        dispatch(premiumCalculatePost(body));
    }, [dispatch, productCode, planCode]);
    return {
        responseCalculate: responseCalculate,
        loadingCalculate: loadingCalculate,
        errorCalculate: errorCalculate,
        calculatePremium: calculatePremium,
        lastBody: lastBody,
    };
};
